import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { BotonDGView as CustomButton } from "./boton";
export type BotonesInicio = "inicio" | "nosotros" | "servicios" | "cobertura" | "sucursales" | "contacto" | "aviso";
export interface TiraBotonesProps {
    selected: BotonesInicio;
    onChange: (x: BotonesInicio) => void;
}

const BotonDGView = kea.defaultProps(CustomButton, {
    width: "110px",
    height: "34px"
});

export class TiraBotonesView extends React.PureComponent<TiraBotonesProps> {
    render() {
        return (
            <div
                style={{
                    display: "flex",
                    marginLeft: "-2px",
                    marginBottom: "10px"
                }}
            >
                <BotonDGView
                    style={this.props.selected == "inicio" ? "pressed" : "normal"}
                    text="Inicio"
                    onClick={() => this.props.onChange("inicio")} />

                <BotonDGView
                    style={this.props.selected == "nosotros" ? "pressed" : "normal"}
                    text="Nosotros"
                    onClick={() => this.props.onChange("nosotros")}
                />

                <BotonDGView
                    style={this.props.selected == "servicios" ? "pressed" : "normal"}
                    text="Servicios"
                    onClick={() => this.props.onChange("servicios")}
                />

                <BotonDGView
                    style={this.props.selected == "cobertura" ? "pressed" : "normal"}
                    text="Cobertura"
                    onClick={() => this.props.onChange("cobertura")}
                />

                <BotonDGView
                    style={this.props.selected == "sucursales" ? "pressed" : "normal"}
                    text="Sucursales"
                    onClick={() => this.props.onChange("sucursales")}
                />

                <BotonDGView
                    style={this.props.selected == "contacto" ? "pressed" : "normal"}
                    text="Contacto"
                    onClick={() => this.props.onChange("contacto")}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/diseño/items/tirabotones.tsx